/* Name:Chaitali Khachane
   Description:This is the pop-up page,this page will render once we click on onboard button on data Assets screen
   in this page we will allow user to fill details to onboard asset like asst name ,description,country ,region etc....
   on Click on submit button it will call submit API and clear all the form values
   or cancel button will discard all the filled value without saving it
               
*/

import React, { Fragment, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Button from "../../component/button/button"
import FormDropdown from "../../component/dropdown/formDropdown"
import ErrorMessage from "../../component/errorMessage/errorMsg"
import FormInputDescription from "../../component/inputtext/formInputDescription"
import Forminputtext from "../../component/inputtext/forminputtext"
import PopUpScreen from "../../component/popUpScreen/popUpScreen"
import { emptyErrorCheck } from "../../helpers/validation/emptyValidation"
import { CLEAR_ALL_ERROR_MESSAGE, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "../../redux/dataAsset/dataAsset.type"
import { emptycheckFields } from "../../validator/pageValidation"
import { FieldLabel } from "../global/global.style"
import { Button as PrimeButton } from 'primereact/button';
import { LabelWrapper } from "../../component/inputtext/inputtextStyle"
import { _alphaNumvalidateInput } from "../../helpers/validation/nameValidation"
import FileExplorerDirectory from "./fileExplorerDirectory"
import FileExplorerFile from "./fileExplorerFile"
import { getADLSFileList, reuploadFile } from "../../redux/dataAsset/dataAsset.action"


function ReloadDataAssetFile({ onHide, changeDetail }) {
    const { formData, apiData } = useSelector((state) => state.dataAsset)
    const dispatch = useDispatch()
    const [editableDataSteward, setEditableDataSteward] = useState(false)
    const [editableProductName, setEditableProductName] = useState(false)
    const [fileExplorerDirectoryEnable, setFileExplorerDirectoryEnable] = useState(false)
    const [fileExplorerFileEnable, setFileExplorerFileEnable] = useState(false)


    //this method will call the redux and set the error message to the passed field
    const setErrorMessage = (fieldname, errorMessage) => {
        dispatch({
            type: SET_ERROR_MESSAGE,
            payload: {
                formField: fieldname,
                isError: true,
                errorMessage: errorMessage
            }
        })
    }
    const onFolderClick = (val) => {
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsDirectoryForm",
                value: val.name
            }
        })
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsFileName",
                value: ""
            }
        })
        dispatch({
            type: SET_FORM_VALUEOBJ,
            payload: {
                formField: "adlsFileName",
                valueAsObj: {}
            }
        })
        dispatch({
            type: SET_FORM_OPTION,
            payload: {
                formField: "adlsFileName",
                data: apiData.adlsDirectory.data.adls_files[val.name]
            }
        })
        setFileExplorerFileEnable(true)
    }
    const onFileClick = (val) => {
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsFileName",
                value: val
            }
        })
    }
    const closeDialog = () => {
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "selectedFile",
                value: null
            }
        })
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsList",
                value: ""
            }
        })
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsDirectoryForm",
                value: ""
            }
        })
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsFileName",
                value: ""
            }
        })
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "filePickUp",
                value: "Local"
            }
        })
        dispatch({
            type: CLEAR_ALL_ERROR_MESSAGE
        })
        onHide()
    }
    return <PopUpScreen style={{ width: "50%" }} header="Update Asset" onHide={() => {
        closeDialog()
    }}
    >
        <div className="grid">
            <div className="col-3" style={{ paddingBottom: "0px" }}>
                {/* <br /> */}
                <FormDropdown
                    required={true}
                    style={{ width: '100%' }} label="Select File"
                    options={formData.filePickUp.options}
                    optionLabel="name"
                    name="filePickUp"
                    value={formData.filePickUp.valueAsObj}
                    onChange={(e) => changeDetail(e, "dropdown", e.target.value.name)}
                />
                <ErrorMessage message={formData.filePickUp.errorMessage} />
            </div>
            <div className="col-9" style={{ paddingBottom: "0px" }}>
                {formData.filePickUp.valueAsObj.name === "Local" ? <Fragment>

                    <input
                        type="file"
                        accept=".csv,.parquet"
                        id="file-input"
                        name="selectedFile"
                        style={{ display: 'none', marginTop: "25px" }}  // Hide the default file input
                        onChange={(e) => changeDetail(e, "file")}
                    />
                    <label
                        htmlFor="file-input"
                        className="custom-file-upload"
                        style={{ width: "100%", marginTop: "21px" }}
                    >
                        <i className="pi pi-plus" style={{ fontWeight: 'bold', fontSize: '10px', marginRight: '4px' }}></i>
                        {formData.selectedFile.value ? formData.selectedFile.value.name : 'Choose file'}
                    </label>
                    <ErrorMessage message={formData.selectedFile.errorMessage} />
                </Fragment> : formData.filePickUp.valueAsObj.name === "ADLS" ? <Fragment>
                    <FormDropdown required style={{ marginRight: "5px", marginBottom: "5px", width: "Calc(100% - 50px)", height: "40px" }}
                        options={formData.adlsList.options}
                        placeholder='Select ADLS' label="ADLS Account" name="adlsList"
                        value={formData.adlsList.valueAsObj}

                        onChange={(e) => {
                            dispatch(getADLSFileList(e.target.value))
                            dispatch({
                                type: SET_FORM_VALUE,
                                payload: {
                                    formField: "adlsDirectoryForm",
                                    value: ""
                                }
                            })
                            dispatch({
                                type: SET_FORM_VALUEOBJ,
                                payload: {
                                    formField: "adlsDirectoryForm",
                                    valueAsObj: {}
                                }
                            })
                            dispatch({
                                type: SET_FORM_VALUE,
                                payload: {
                                    formField: "adlsFileName",
                                    value: ""
                                }
                            })
                            dispatch({
                                type: SET_FORM_VALUEOBJ,
                                payload: {
                                    formField: "adlsFileName",
                                    valueAsObj: {}
                                }
                            })
                            changeDetail(e, "dropdown", e.target.value)
                        }
                        } /><PrimeButton onClick={() => setFileExplorerDirectoryEnable(true)} style={{ width: "40px", height: "40px", verticalAlign: "baseline" }} icon="pi pi-search" aria-label="Search" />
                    <ErrorMessage message={formData.adlsList.errorMessage} />

                    {/* <FormDropdown required style={{ marginBottom: "5px", width: "100%", height: "40px" }} options={formData.adlsDirectoryForm.options} placeholder='Select Directory ' optionLabel="name" label="Select Directory" name="adlsDirectoryForm" value={formData.adlsDirectoryForm.valueAsObj} onChange={(e) => {
                                changeDetail(e, "dropdown", e.target.value.name)
                                dispatch({
                                    type: SET_FORM_VALUE,
                                    payload: {
                                        formField: "adlsFileName",
                                        value: ""
                                    }
                                })
                                dispatch({
                                    type: SET_FORM_VALUEOBJ,
                                    payload: {
                                        formField: "adlsFileName",
                                        valueAsObj: {}
                                    }
                                })
                                dispatch({
                                    type: SET_FORM_OPTION,
                                    payload: {
                                        formField: "adlsFileName",
                                        data: apiData.adlsDirectory.data.adls_files[e.target.value.name]
                                    }
                                })
                            }} />
                            <ErrorMessage message={formData.adlsDirectoryForm.errorMessage} /> */}

                    {/* <FormDropdown required style={{ marginBottom: "5px", width: "100%", height: "40px" }} options={formData.adlsFileName.options} placeholder='Select File ' label="Select File" name="adlsFileName" value={formData.adlsFileName.value} onChange={(e) => changeDetail(e, "dropdown", e.target.value)} />
                            <ErrorMessage message={formData.adlsFileName.errorMessage} /> */}
                    <div style={{ marginLeft: "5px", marginTop: "5px" }}>Selected File : {formData.adlsFileName.value}</div>
                </Fragment> : ""}

            </div>
        </div>
        <div style={{ marginTop: "5px", textAlign: "right" }}>
            <Button style={{ textAlign: "center" }} iconEnable={false} value="Upload" onClick={() => {
                if(emptyErrorCheck(emptycheckFields.reUpload, formData, setErrorMessage).length > 0){

                }else{
                dispatch(reuploadFile(apiData.assetSummary.data.data_asset_name))
                closeDialog()
                }
                
            }} />
        </div>

        {fileExplorerDirectoryEnable ? <FileExplorerDirectory onFolderClick={onFolderClick} closeDialog={() => {
            setFileExplorerDirectoryEnable(false)

        }
        } directoryLabelKey="name" directory={formData.adlsDirectoryForm.options} loading={apiData.adlsDirectory.loading} /> : ""}
        {fileExplorerFileEnable ? <FileExplorerFile
            backClick={() => {
                setFileExplorerFileEnable(false)
                dispatch({
                    type: SET_FORM_VALUE,
                    payload: {
                        formField: "adlsDirectoryForm",
                        value: ""
                    }
                })
                dispatch({
                    type: SET_FORM_VALUE,
                    payload: {
                        formField: "adlsFileName",
                        value: ""
                    }
                })
                setFileExplorerDirectoryEnable(true)
            }
            } onFileClick={onFileClick}
            closeDialog={() => {
                setFileExplorerFileEnable(false)
            }
            }
            label={formData.adlsDirectoryForm.value}
            file={formData.adlsFileName.options} loading={false} /> : ""}

    </PopUpScreen>
}
export default ReloadDataAssetFile